import * as React from "react";
import { graphql, HeadFC, PageProps, useStaticQuery } from "gatsby";
import Layout from "../../../components/Layout";
import { Heading } from "../../../components/Heading";
import { CircleTeasers } from "../../../components/content/CircleTeasers";
import { Separator } from "../../../components/Separator";
import { MediaText } from "../../../components/MediaText";
import { getImage } from "gatsby-plugin-image";

import { Container } from "../../../components/Container";
import { Gallery, GalleryItemProps } from "../../../components/Gallery";
import { Seo } from "../../../components/Seo";

const TagesablaufPage: React.FC<PageProps> = ({ location }) => {
  const data = useStaticQuery(graphql`
    {
      items: allFile(
        limit: 1000
        filter: { relativeDirectory: { eq: "alltag/tagesablauf/images" } }
        sort: { base: ASC }
      ) {
        nodes {
          ...GalleryImages
        }
      }
    }
  `);
  const items: GalleryItemProps[] = data.items.nodes.map(
    (node: GalleryItemProps) => ({
      thumb: getImage(node.thumb),
      large: getImage(node.large),
    }),
  );
  return (
    <Layout
      location={location}
      startBackgroundClassName={"fill-grey"}
      endBackgroundClassName={"fill-white"}
    >
      <main className={"bg-grey overflow-hidden"}>
        <MediaText media={<Gallery items={items} cols={2} />}>
          <Heading
            level={1}
            textAlign={"left"}
            title={"Der Tagesablauf"}
            subline={"in unseren Einrichtungen"}
            className={"mt-16 mb-8"}
          />
          <p>
            Morgens haben die Kinder die Möglichkeit, in ihrem eigenen Tempo und
            mit allen Sinnen anzukommen, bevor wir den Tag in einem gemeinsamen
            Morgenkreis begrüßen. Da wir kleine Einrichtungen sind, wird bei uns
            jedes Kind persönlich begrüßt und willkommen geheißen.
          </p>
          <p>
            Nach einem gemeinsamen Frühstück und dem obligatorischen Zähneputzen
            erwarten die Kinder{" "}
            <strong className={"font-bold"}>
              täglich wechselnde Spiel-, Spaß- und Kreativitätsangebote
            </strong>
            , die bei schönem Wetter selbstverständlich auch im Garten
            stattfinden und jedes Kind in all seinen Fähigkeiten stärkt und
            gleichzeitig seine individuellen Vorlieben und Talente
            berücksichtigt.
          </p>
          <p>
            Eine gesunde und ausgewogene Ernährung ist für uns sehr wichtig. Aus
            diesem Grund bereiten in allen Einrichtungen unsere guten Geister
            rund um die Hauswirtschaft unsere Mahlzeiten frisch zu. Neben einem
            ausgewogenen Frühstück und Mittagessen gibt es täglich einen
            Nachmittagssnack. Damit wir genug Energie für unsere Abenteuer
            haben, stehen viel Obst und Gemüse auf unserem Speiseplan.
          </p>
          <Heading
            title={"Ruhe und Schlaf für eine optimale Balance"}
            level={2}
            textAlign={"left"}
            className={"mt-4"}
          />
          <p>
            Nach dem Mittagessen haben die Kinder die Möglichkeit, einen{" "}
            <strong className={"font-bold"}>Mittagsschlaf</strong> zu machen,
            sich kurz auszuruhen oder sich z. B.{" "}
            <strong className={"font-bold"}>
              eine Geschichte in unserer Leseecke vorlesen zu lassen
            </strong>{" "}
            und so zur Ruhe zu kommen.
          </p>
          <p>
            Sind alle Kinder wieder fit, brechen wir - frisch gestärkt vom
            Nachmittagssnack – noch einmal zu neuen Spielen, Abenteuern und
            Entdeckungsreisen auf.
          </p>
        </MediaText>
        <Separator className={"transform -scale-y-100 fill-white"} />
        <Container align={"full"} className={"bg-white"}>
          <CircleTeasers />
        </Container>
      </main>
    </Layout>
  );
};

export default TagesablaufPage;

export const Head: HeadFC = () => <Seo title={["Tagesablauf", "Alltag"]} />;
